import { Answer } from "../../models/RestModels";

export function getEmptyAnswer(): Answer
{
		return{
			id:0,
			answer_choice_id:0,
			answer_number:0,
			answer_text:'',
			question_id:0,
			response_id:0,
		}
}
